<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div
      v-if="
        data.item.motivoRechazo != null ||
          data.item.motivoRechazo != ''
      "
    >
      <b-button @click="showModal(data.item)"
        variant="outline-info" >Ver Motivo</b-button
      >


    </div>
 
  </div>
</template>

<script>
export default {
  name: "BandejaMotivoRechazoComponente",
  props: {
    data: Object,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created(){
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    showModal(idSolicitudDiagnostico) {
      this.$emit("_funcionExtra2", idSolicitudDiagnostico);
    },
  },
};
</script>
